import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { BodyShort01 } from 'module/ui/components/styles';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Banner = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  /* 35px is the target single-line height, but a fixed height would clip a
     wrapped message (narrower sidebar, longer translation) — min-height lets
     it grow instead. */
  min-height: 35px;
  gap: var(--spacing-05);
  padding: 0 var(--spacing-03) 0 var(--spacing-05);
  border-radius: var(--Radius-8, 8px);
  border: 1px solid var(--Default-Red-10, #fff1f1);
  background: var(--Default-Red-10, #fff1f1);
`;

const Icon = styled(FontAwesomeIcon)`
  color: var(--red-50, #fa4d56);
  flex-shrink: 0;
`;

const Message = styled.span`
  ${BodyShort01};
  color: var(--text-primary);
`;

/** Shown above the transcript when the thread includes a blocked contact. Shared by the emails-v2 page and the email-thread drawer. */
export const BlockedContactBanner = () => (
  <Banner data-cy="blocked-contact-banner">
    <Icon icon={faCircleExclamation} size={14} />
    <Message>
      <FormattedMessage
        id="account.email_pages.blocked_contact_banner"
        defaultMessage="This thread includes a blocked contact, so new emails are no longer synced."
      />
    </Message>
  </Banner>
);
